import { render, staticRenderFns } from "./Acknowledgement.vue?vue&type=template&id=d1fe4d06&scoped=true&"
import script from "./Acknowledgement.vue?vue&type=script&lang=js&"
export * from "./Acknowledgement.vue?vue&type=script&lang=js&"
import style0 from "./Acknowledgement.vue?vue&type=style&index=0&id=d1fe4d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fe4d06",
  null
  
)

export default component.exports